import { type JSX } from "react";

import { Combobox as BaseCombobox } from "@base-ui/react/combobox";

import type { ComboboxGroupProps } from "./Combobox.types";

export function ComboboxGroup({ ...props }: ComboboxGroupProps): JSX.Element {
  return <BaseCombobox.Group data-slot="combobox-group" {...props} />;
}
